// extracted by mini-css-extract-plugin
module.exports = {"container":"X13vfg4y","avatar":"IQVEhWPU","tooltip":"LBrbzpzm","name":"_4VHTYRYD","id":"FYd2cow0"};